export default __webpack_public_path__ + "static/media/Gcash.4af3922e.png";